/** CSS object-position from stored 0–100 image focal-point coordinates. */
export function imageFocalPosition(x?: number | null, y?: number | null) {
  const coordinate = (value?: number | null) =>
    typeof value === 'number' && Number.isFinite(value)
      ? Math.max(0, Math.min(100, value))
      : 50;
  return `${coordinate(x)}% ${coordinate(y)}%`;
}
